import { Component, OnInit } from '@angular/core';
import { AppCollectionService, TargetAppService } from 'src/app/modules/core/services/parameter';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';

@Component({
  selector: 'app-navbar-change-system',
  templateUrl: './navbar-change-system.component.html',
  styleUrls: ['./navbar-change-system.component.scss']
})
export class NavbarChangeSystemComponent implements OnInit {

  public appsEnabled: any[];
  public showTooltip: boolean;

  constructor(
    private readonly appCollectionService: AppCollectionService,
    private readonly currentAppService: TargetAppService
  ) {
    this.appsEnabled = [];
    this.showTooltip = false;
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    this.currentAppService.getObservable().subscribe((currentApp: IRawApplication) => {
      const applications = this.appCollectionService.get();
      // Filter applications which aren't the current app
      this.appsEnabled = applications.filter((app) => app.name !== currentApp.name);
    });
  }

}
